import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * disabled: true                 if set true, item will disabled link in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    activeMenuParent: true     if set true, the parent item will highlight
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
  },
  {
    path: "/macroregions",
    component: Layout,
    redirect: "/macroregions/list",
    meta: {
      title: "Макрорегионы",
      icon: "city-solid",
      activeMenuParent: true,
      roles: ["super_admin"],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/MacroregionsTable.vue"),
        meta: { title: "Макрорегионы", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/forms/MacroregionsForm.vue"),
        meta: { title: "Создать макрорегионы", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/forms/MacroregionsForm.vue"),
        meta: { title: "Редактировать макрорегионы", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/regions",
    component: Layout,
    redirect: "/regions/list",
    meta: {
      title: "Регионы",
      icon: "city-solid",
      activeMenuParent: true,
      roles: ["super_admin"],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/RegionsTable.vue"),
        meta: { title: "Регионы", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/forms/RegionsForm.vue"),
        meta: { title: "Создать регион", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/forms/RegionsForm.vue"),
        meta: { title: "Редактировать регион", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/doc-type",
    component: Layout,
    redirect: "/doc-type/list",
    meta: {
      title: "Типы документов",
      icon: "tree",
      activeMenuParent: true,
      roles: ["super_admin", "section_admin"],
    },
    children: [
      {
        path: "/doc-type/list",
        component: () => import("@/views/table/DocumentsTypeTable.vue"),
        meta: { title: "Типы документов", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "/doc-type/create",
        component: () => import("@/views/forms/DocumentsTypeForm.vue"),
        meta: { title: "Создать тип документа", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "/doc-type/edit/:id",
        component: () => import("@/views/forms/DocumentsTypeForm.vue"),
        meta: { title: "Редактировать тип документа", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/doc-sections",
    component: Layout,
    redirect: "/doc-sections/list",
    meta: {
      title: "Секции документов",
      icon: "elementor-brands",
      activeMenuParent: true,
      roles: ["super_admin", "section_admin"],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/DocumentSectionsTable.vue"),
        meta: { title: "Секции документов", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/forms/DocumentSectionsForm.vue"),
        meta: { title: "Создать секцию документа", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/forms/DocumentSectionsForm.vue"),
        meta: {
          title: "Редактировать секцию документа",
          activeMenuParent: true,
        },
        hidden: true,
      },
    ],
  },
  {
    path: "/docs",
    component: Layout,
    redirect: "/docs/list",
    meta: {
      title: "Документы",
      icon: "form",
      activeMenuParent: true,
      roles: [
        "super_admin",
        "section_admin",
        "regional_admin",
        "federal_admin",
        "all_document_admin",
      ],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/DocumentsTable.vue"),
        meta: { title: "Документы", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create/regional",
        component: () => import("@/views/forms/DocumentsForm.vue"),
        meta: {
          title: "Создать региональный документ",
          activeMenuParent: true,
        },
        hidden: true,
      },
      {
        path: "create/federal",
        component: () => import("@/views/forms/DocumentsForm.vue"),
        meta: { title: "Создать федеральный документ", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/federal/:id",
        component: () => import("@/views/forms/DocumentsForm.vue"),
        meta: { title: "Редактировать документ", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/regional/:id",
        component: () => import("@/views/forms/DocumentsForm.vue"),
        meta: { title: "Редактировать документ", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/users",
    component: Layout,
    redirect: "/users/list",
    meta: {
      title: "Пользователи",
      icon: "user",
      activeMenuParent: true,
      roles: ["super_admin"],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/UsersTable.vue"),
        meta: { title: "Пользователи", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/forms/UsersForm.vue"),
        meta: { title: "Создать пользователя", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/forms/UsersForm.vue"),
        meta: {
          title: "Редактировать пользователя",
          activeMenuParent: true,
        },
        hidden: true,
      },
    ],
  },
  {
    path: "/toolkits",
    component: Layout,
    redirect: "/toolkits/list",
    meta: {
      title: "Тулкиты",
      icon: "example",
      activeMenuParent: true,
      roles: ["super_admin", "section_admin"],
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/table/ToolkitsTable.vue"),
        meta: { title: "Тулкиты", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/forms/ToolkitsForm.vue"),
        meta: { title: "Создать тулкит", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/forms/ToolkitsForm.vue"),
        meta: { title: "Редактировать тулкит", activeMenuParent: true },
        hidden: true,
      },
    ],
  },

  { path: "*", redirect: "/404", hidden: true },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.match = newRouter.match; // reset router
}

export default router;
